import axiosConfig from "./axiosConfig";

export interface NextDocumentNumberResponse {
  type: string;
  nextNumber: number;
  formatted: string;
}

const getNextDocumentNumber = async (
  authToken: string,
  type: string
): Promise<NextDocumentNumberResponse> => {
  const { data } = await axiosConfig.get(
    `/document-ids/next?type=${encodeURIComponent(type)}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default getNextDocumentNumber;
